var bookshelf = require("../index-extended");
require("./ResolutionCatalog");
require("./ResolutionCatalogTag");

module.exports = bookshelf.model("Tag", {
  entityName: "Tag",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "tag",
  resolutions_catalogs() {
    return this.belongsToMany(
      "ResolutionCatalog",
      "resolution_catalog_tag",
      "tag_id",
      "resolution_catalog_id"
    );
  },

  // HACK: get join table items
  resolution_catalog_tags() {
    return this.hasMany("ResolutionCatalogTag", "tag_id");
  },

  format(attrs) {
    delete attrs["$id"];
    // delete attrs["@id"];
    delete attrs["resolution_catalog_tags"];

    return attrs;
  },
});
